import { ginzaxiaomaApiRequest } from './index';

type InitializeAssetsParams = {
  productIds: number[];
};

const xmAssetsApi = {
  initializeAssets(params: InitializeAssetsParams): Promise<void> {
    return ginzaxiaomaApiRequest.post<void>(
      '/admin/xm-assets/initialize-assets',
      params,
    ) as unknown as Promise<void>;
  },
};

export default xmAssetsApi;